/* eslint-disable no-undef */
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.thumbnails = this.querySelector('[data-thumbnails]');
    this.container = document.querySelector('[data-gallery-container]');
    window.addEventListener('load', () => {
      this.init();
      this.container.addEventListener('theme:gallery:reinit', (event) => {
            this.init();
      });
    });

    this.slides = [...this.querySelectorAll('.gallery-video')];
    this.slides.forEach(el => el.addEventListener('click', (e) => {
        this.classList.add('modal');
    }));
    this.overlay = [...this.querySelectorAll('.product-gallery-overlay')];
    this.overlay.forEach(el => el.addEventListener('click', (e) => {
        this.classList.toggle('modal');
    }));
    this.overlay = [...this.querySelectorAll('.exit-button')];
    this.overlay.forEach(el => el.addEventListener('click', (e) => {
        
        this.classList.toggle('modal');
        var videos = document.querySelectorAll('iframe, video');
        Array.prototype.forEach.call(videos, function (video) {
          if (video.tagName.toLowerCase() === 'video') {
            video.pause();
          } else {
            var src = video.src;
            video.src = src;
          }
        });
    }));

  }

  init(){
    this.thumbSlider = new Swiper('[data-thumbnails]', {
      slidesPerView: 6,
      spaceBetween: 0,
      freeMode: true,
      watchSlidesProgress: true,

    });
    this.main = new Swiper('[data-main-gallery]',{
      spaceBetween: 10,
      navigation: false,
      zoom: true,
      thumbs: {
        swiper: this.thumbSlider,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
          nextEl: '[data-swiper-button-next]',
          prevEl: '[data-swiper-button-prev]',
      },
      on: {
        click() {
             this.zoom.toggle() 
        },
      },
      

    });
    const zoom = this.querySelector('[data-zoom-element]');
    if(zoom){
      zoom.addEventListener('click', () => {
        this.main.zoom.toggle();
      });
    }
    if(this.thumbSlider.slides.length > 1){
        document.querySelector('[data-thumbnails]').classList.remove('opacity-0');
    }
  }
}
customElements.define('product-gallery', ProductGallery);
